import React, { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Btn, Card, Field, Input, Select } from "./ui";
import { errMsg } from "./api";

export const Localidades = ({ client, meta, onChange }) => {
  const [prov, setProv] = useState("");
  const [loc, setLoc] = useState("");
  const [busy, setBusy] = useState(false);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await client.post("/localidades", { provincia: prov, localidad: loc });
      toast.success("Localidad agregada");
      setLoc("");
      onChange();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const del = async (l) => {
    if (!window.confirm(`¿Quitar ${l.localidad}?`)) return;
    await client.delete(`/localidades/${l.id}`).catch((e) => toast.error(errMsg(e)));
    onChange();
  };

  const byProv = meta.provincias.map((p) => [p, meta.localidades.filter((l) => l.provincia === p)]);

  return (
    <div className="space-y-6" data-testid="red-localidades">
      <Card title="Agregar localidad">
        <p className="text-sm text-gray-500 mb-4">Las localidades cargadas aparecen como sugerencias en todos los formularios. Igual se puede escribir una localidad nueva.</p>
        <form onSubmit={add} className="grid sm:grid-cols-3 gap-3 items-end">
          <Field label="Provincia"><Select required value={prov} placeholder="Elegí…" options={meta.provincias} onChange={(e) => setProv(e.target.value)} data-testid="loc-provincia" /></Field>
          <Field label="Localidad"><Input required minLength={2} value={loc} onChange={(e) => setLoc(e.target.value)} data-testid="loc-localidad" /></Field>
          <Btn type="submit" busy={busy} data-testid="loc-agregar">Agregar</Btn>
        </form>
      </Card>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {byProv.map(([p, ls]) => (
          <div key={p} className="bg-white border border-gray-200 p-4" data-testid={`loc-prov-${p}`}>
            <div className="font-headings uppercase tracking-wide text-sm text-[#0A2463] mb-2 flex justify-between">{p}<span className="text-gray-400">{ls.length}</span></div>
            {ls.length === 0 ? <p className="text-xs text-gray-400">Sin localidades cargadas</p> : (
              <ul className="space-y-1">
                {ls.map((l) => (
                  <li key={l.id} className="flex justify-between items-center text-sm group">
                    {l.localidad}
                    <button onClick={() => del(l)} className="text-gray-300 hover:text-red-600" data-testid={`loc-del-${l.id}`}><Trash2 size={14} /></button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Localidades;
